'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    const formulars = document.querySelectorAll('.customform-form');
    
    if ( formulars ) {
        formulars.forEach((formular) => {
          if ( formular.classList.contains('form-has-country-codes') ) {
            phoneCountryFunctions(formular);
          }
          
          if ( formular.classList.contains('form-has-steps') || formular.classList.contains('form-has-custom-validation') ) {
            validateFormular(formular);
          }

          var form_submit_response = formular.querySelector('.customform-response');
          if ( form_submit_response ) {
            form_submit_response.scrollIntoView({ behavior: 'smooth' });
          }
        });

        function submitFormular(formular) {
            // formular.addEventListener('submit', (e) => {
            //     e.preventDefault();
            //     e.stopPropagation();

            //     validateFormular(formular);
            // });
        }

        function validateFormular(formular) {
            var submit_btn = formular.querySelector('.customform-submit');
            if ( formular.classList.contains('form-has-steps') ) {              
              submit_btn.addEventListener('click', (e) => {
                  e.stopPropagation();

                  var current_container = formular.querySelector('.customform-field-container.current'),
                      container_validated = validateContainer(current_container);

                  if ( container_validated == true ) {
                      current_container.classList.add('validated');

                      var next_container = current_container.nextElementSibling;
                      if ( next_container.classList.contains('customform-field-container') ) {
                          var next_btn_text = next_container.getAttribute('data-step-btn-text');

                          current_container.style.display = 'none';
                          current_container.classList.add('hidden');
                          current_container.classList.remove('current');

                          if ( next_btn_text ) submit_btn.innerText = next_btn_text;

                          next_container.style.display = 'block';
                          next_container.classList.remove('hidden');
                          next_container.classList.add('current');

                          var scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
                              header_height = window.innerWidth > 960 ? 150 : 120,
                              elmnt_scrollTop = scrollTop + next_container.getBoundingClientRect().top - header_height;

                          scrollTo(elmnt_scrollTop, 500);

                          return;
                      }

                      submit_btn.setAttribute('type', 'submit');
                  }
              });
            } else {
              submit_btn.addEventListener('click', (e) => {
                e.stopPropagation();

                var current_container = formular.querySelector('.customform-field-container'),
                    container_validated = validateContainer(current_container);

                if ( container_validated == true ) {
                  submit_btn.setAttribute('type', 'submit');
                }
              });
            }
        }

        function validateContainer(container) {
            const required_fields = container.querySelectorAll('.customform-field-required');
            var all_fields_validated = true,
                first_error_field    = false;

            if ( required_fields ) {
                for (let i = 0; i < required_fields.length; i++) {
                    var field                   = required_fields[i],
                        field_type              = field.getAttribute('data-field-type'),
                        field_validate          = field_type == 'checkbox' || field_type == 'radio'
                          ? field
                          : field.querySelector('.customform-field-validate');

                    if ( validateField(field_validate, field_type) == false ) {
                      all_fields_validated = false;

                      if ( first_error_field == false ) {
                        first_error_field = field_validate;

                        var scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
                        header_height = window.innerWidth > 960 ? 150 : 120,
                        elmnt_scrollTop = scrollTop + first_error_field.getBoundingClientRect().top - header_height;

                        scrollTo(elmnt_scrollTop, 500);
                      }
                    }
                };
            }

            return all_fields_validated;
        }

        function validateField(field, field_type) {
            var field_validated = false,
                field_value     = field.value,
                error_label     = field.closest('.customform-field').getAttribute('data-label-required');

            if ( field_type == 'checkbox' || field_type == 'radio') {
              var input_elms = field.querySelectorAll('input[type="checkbox"],input[type="radio"]'),
                  has_checked_input = false;

              input_elms.forEach((input_elm) => {
                if (input_elm.checked) {
                  has_checked_input = true;
                }
              });

              if ( has_checked_input == true ) {
                field_validated = true;
              }
            } else if ( field_type == 'email' ) {
                var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    email_domain_regex = field.getAttribute('data-email-domain-blacklist'),
                    email_domains = email_domain_regex.split(','),
                    user_email = field_value.split('@').pop();

                if ( field_value != "" ) {
                    if (field_value.match(mailformat)) {
                        if ( email_domain_regex != '' ) {
                            if ( email_domains.includes(user_email)  ) {
                                var error_label = "Business email domains only";
                            } else {
                                field_validated = true;
                            }
                        } else {
                            field_validated = true;
                        }
                    } else {
                        var error_label = field.parentNode.getAttribute('data-label-special');

                        //return false;
                    }
                }
            } else if ( field_type == 'tel' ) {
                var phoneno = /^\+?(\d{2} ?){4,5}/;

                if (field_value != "") {
                    if (field_value.match(phoneno)) {
                        field_validated = true;
                    } else {
                        var error_label = field.parentNode.getAttribute('data-label-special');

                        //return false;
                    }
                }
            } else {
                if ( field_value != "" ) {
                    field_validated = true;
                }
            }

            if ( field_validated == false ) {
                field.classList.add('customform-error');
            } else {
                field.classList.remove('customform-error');
            }

            toggleErrorLabel(field, field_validated, error_label);

            return field_validated;
        }

        function toggleErrorLabel(field, field_validated, error_label) {
            field = field.closest('.customform-field');
            var error_label_elm = field.querySelector('label.customform-error');

            if ( field_validated == true ) {
                if ( error_label_elm ) {
                    field.removeChild(error_label_elm);
                }
            } else {
                if ( !error_label_elm ) {
                    error_label_elm = document.createElement('label');
                    error_label_elm.classList.add('customform-error');
                    error_label_elm.innerText = error_label;

                    field.appendChild(error_label_elm);
                } else {
                    error_label_elm.innerText = error_label;
                }
            }
        }

        function phoneCountryFunctions(formular) {
            // get the country data from the plugin
            const input = formular.querySelector(".js-iti-phone");

            if ( !input ) return;

            // init plugin
            const excludedCountriesArray = ["af", "by", "cu", "ir", "iq", "kp", "ru", "sy", "ve", "ye"];
            const iti = window.intlTelInput(input, {
                initialCountry: "auto",
                excludeCountries: excludedCountriesArray,
                geoIpLookup: callback => {
                    fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback("us"));
                }
            });
            
            const addressDropdown = formular.querySelector(".js-iti-address-country");
            if ( !addressDropdown ) return;

            const countryData = window.intlTelInputGlobals.getCountryData();

            // populate the country dropdown
            for (let i = 0; i < countryData.length; i++) {
                const country = countryData[i];

                // Check if country is in the excludedCountriesArray
                if ( excludedCountriesArray.includes(country.iso2) ) continue;

                const optionNode = document.createElement("option");
                optionNode.value = country.iso2;
                const textNode = document.createTextNode(country.name);
                optionNode.appendChild(textNode);
                addressDropdown.appendChild(optionNode);
            }
            // set it's initial value
            addressDropdown.value = iti.getSelectedCountryData().iso2;

            // listen to the telephone input for changes
            input.addEventListener('countrychange', () => {
                addressDropdown.value = iti.getSelectedCountryData().iso2;
            });

            // listen to the address dropdown for changes
            addressDropdown.addEventListener('change', () => {
                iti.setCountry(this.value);
            });
        }
    }

    var scrollTo = function(to, duration) {
        var element = document.scrollingElement || document.documentElement,
            start = element.scrollTop,
            change = to - start,
            startDate = +new Date(),
            // t = current time
            // b = start value
            // c = change in value
            // d = duration
            easeInOutQuad = function(t, b, c, d) {
                t /= d/2;
                if (t < 1) return c/2*t*t + b;
                t--;
                return -c/2 * (t*(t-2) - 1) + b;
            },
            animateScroll = function() {
                var currentDate = +new Date();
                var currentTime = currentDate - startDate;
                element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
                if(currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
                else {
                    element.scrollTop = to;
                }
            };
            
        animateScroll();
    };
});


